import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { selectStyles, selectTheme } from '../theme/selectTheme';

const API_URL = '/api'; // api/sundargarh/[...slug].js (Kobo-backed, not the Express backend)
const toOptions = (arr) => (arr || []).map((v) => ({ value: v, label: v }));

// Filter bar for every Sundargarh (live KoboToolbox) screen — ULB / Ward /
// Enumerator (multi-select) + Start/End Date. Counterpart to the internal
// app's <FilterBar>, which is wired to the internal block/GP/village cascade
// this data source doesn't have.
export default function SundargarhFilterBar({ onApply, onClear, loading }) {
  const [options, setOptions] = useState({ ulbs: [], wards: [], enumerators: [] });
  const [temp, setTemp] = useState({ ulbs: [], wards: [], enumerators: [], startDate: '', endDate: '' });

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(`${API_URL}/sundargarh/filters`);
        if (active && res.data?.success) {
          setOptions({
            ulbs: toOptions(res.data.ulbs),
            wards: toOptions(res.data.wards),
            enumerators: toOptions(res.data.enumerators),
          });
        }
      } catch (err) {
        console.error('Error fetching Sundargarh filter options:', err);
      }
    })();
    return () => { active = false; };
  }, []);

  const handleSelect = (name) => (opts) => setTemp((p) => ({ ...p, [name]: opts || [] }));
  const handleDate = (e) => setTemp((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleApply = () => onApply({
    ulbs: temp.ulbs.map((o) => o.value),
    wards: temp.wards.map((o) => o.value),
    enumerators: temp.enumerators.map((o) => o.value),
    startDate: temp.startDate,
    endDate: temp.endDate,
  });

  const handleClear = () => {
    setTemp({ ulbs: [], wards: [], enumerators: [], startDate: '', endDate: '' });
    onClear();
  };

  return (
    <div className="filterbar">
      <div className="filterbar-head">
        <FilterListIcon fontSize="small" /> Filter by ULB, Ward &amp; Enumerator
      </div>
      <div className="filter-grid">
        <div className="filter-group">
          <label>ULB</label>
          <Select
            isMulti
            options={options.ulbs}
            value={temp.ulbs}
            onChange={handleSelect('ulbs')}
            placeholder="All ULBs"
            styles={selectStyles}
            theme={selectTheme}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            isClearable
          />
        </div>
        <div className="filter-group">
          <label>Ward</label>
          <Select
            isMulti
            options={options.wards}
            value={temp.wards}
            onChange={handleSelect('wards')}
            placeholder="All wards"
            styles={selectStyles}
            theme={selectTheme}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            isClearable
          />
        </div>
        <div className="filter-group">
          <label>Enumerator</label>
          <Select
            isMulti
            options={options.enumerators}
            value={temp.enumerators}
            onChange={handleSelect('enumerators')}
            placeholder="All enumerators"
            styles={selectStyles}
            theme={selectTheme}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            isClearable
          />
        </div>
        <div className="filter-group">
          <label>Start Date</label>
          <input type="date" name="startDate" value={temp.startDate} onChange={handleDate} />
        </div>
        <div className="filter-group">
          <label>End Date</label>
          <input type="date" name="endDate" value={temp.endDate} onChange={handleDate} />
        </div>
      </div>
      <div className="filter-actions">
        <button className="btn btn-primary" onClick={handleApply} disabled={loading}>
          <SearchIcon fontSize="small" /> {loading ? 'Applying…' : 'Apply Filters'}
        </button>
        <button className="btn btn-secondary" onClick={handleClear} disabled={loading}>
          <ClearIcon fontSize="small" /> Clear
        </button>
      </div>
    </div>
  );
}
